/* LEMOBILE — assets/lemobile-repair-form.js
   Cascade marque -> modèle pour le formulaire de devis réparation.
   Préremplissage marque/modèle/réparation depuis les paramètres d'URL
   envoyés par le sélecteur "Trouvez votre réparation en 3 clics"
   (?marque=...&modele=...&reparation=...#lm-devis).
   + Filet de sécurité WhatsApp : après soumission réussie, propose un
   envoi WhatsApp pré-rempli en complément de l'email Shopify natif,
   pour garantir la réception même en cas de souci de configuration
   email côté Shopify Notifications. */
(function () {
  var WHATSAPP_NUMBER = '33754009553';

  var MODELS = {
    "Apple": [
      "iPhone 8 / 8 Plus", "iPhone X", "iPhone XR", "iPhone XS", "iPhone XS Max",
      "iPhone 11", "iPhone 11 Pro", "iPhone 11 Pro Max", "iPhone SE (2e gen)",
      "iPhone 12", "iPhone 12 Mini", "iPhone 12 Pro", "iPhone 12 Pro Max",
      "iPhone 13", "iPhone 13 Mini", "iPhone 13 Pro", "iPhone 13 Pro Max",
      "iPhone SE (3e gen)", "iPhone 14", "iPhone 14 Plus", "iPhone 14 Pro", "iPhone 14 Pro Max",
      "iPhone 15", "iPhone 15 Plus", "iPhone 15 Pro", "iPhone 15 Pro Max",
      "iPhone 16", "iPhone 16e", "iPhone 16 Plus", "iPhone 16 Pro", "iPhone 16 Pro Max",
      "iPhone 17", "iPhone 17 Air", "iPhone 17 Pro", "iPhone 17 Pro Max"
    ],
    "Samsung": [
      "Galaxy S22", "Galaxy S22+", "Galaxy S22 Ultra",
      "Galaxy S23", "Galaxy S23+", "Galaxy S23 Ultra",
      "Galaxy S24", "Galaxy S24+", "Galaxy S24 Ultra",
      "Galaxy S25", "Galaxy S25+", "Galaxy S25 Ultra",
      "Galaxy A33", "Galaxy A34", "Galaxy A35", "Galaxy A36",
      "Galaxy A53", "Galaxy A54", "Galaxy A55", "Galaxy A56",
      "Galaxy Z Fold 5", "Galaxy Z Fold 6", "Galaxy Z Flip 5", "Galaxy Z Flip 6",
      "Galaxy Note 20", "Galaxy Note 20 Ultra",
      "Galaxy S (autre génération)", "Galaxy A (autre génération)"
    ],
    "Autre": ["Autre modèle (précisez dans la description)"]
  };

  document.addEventListener('DOMContentLoaded', function () {
    var brandSelect = document.getElementById('lm-rep-brand');
    var modelSelect = document.getElementById('lm-rep-model');
    var repairSelect = document.getElementById('lm-rep-repair-type');
    var fileInput = document.getElementById('lm-rep-photos');
    var fileList = document.getElementById('lm-rep-file-list');
    var fileLabel = fileInput ? fileInput.closest('.lm-rep-file').querySelector('.lm-rep-file-text') : null;

    var params = new URLSearchParams(window.location.search);
    var presetBrand = params.get('marque');
    var presetModel = params.get('modele');
    var presetRepair = params.get('reparation');

    function populateModels(brand, selectValue) {
      if (!modelSelect) return;
      modelSelect.innerHTML = '';
      if (!brand || !MODELS[brand]) {
        var opt = document.createElement('option');
        opt.value = '';
        opt.textContent = "Choisissez d'abord une marque";
        modelSelect.appendChild(opt);
        modelSelect.disabled = true;
        return;
      }
      modelSelect.disabled = false;
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Sélectionnez votre modèle...';
      modelSelect.appendChild(placeholder);
      var matched = false;
      MODELS[brand].forEach(function (model) {
        var o = document.createElement('option');
        o.value = model;
        o.textContent = model;
        modelSelect.appendChild(o);
      });
      if (selectValue) {
        var exists = MODELS[brand].indexOf(selectValue) !== -1;
        if (!exists) {
          var custom = document.createElement('option');
          custom.value = selectValue;
          custom.textContent = selectValue;
          modelSelect.appendChild(custom);
        }
        modelSelect.value = selectValue;
        matched = true;
      }
      return matched;
    }

    if (brandSelect) {
      brandSelect.addEventListener('change', function () {
        populateModels(this.value);
      });
      if (presetBrand && (presetBrand === 'Apple' || presetBrand === 'Samsung')) {
        brandSelect.value = presetBrand;
        populateModels(presetBrand, presetModel);
      }
    }

    if (repairSelect && presetRepair) {
      var repairExists = Array.prototype.some.call(repairSelect.options, function (o) { return o.value === presetRepair; });
      if (repairExists) {
        repairSelect.value = presetRepair;
      }
    }

    if ((presetBrand || presetModel || presetRepair) && window.location.hash === '#lm-devis') {
      var devisSection = document.getElementById('lm-devis');
      if (devisSection) {
        setTimeout(function () {
          devisSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      }
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var files = Array.prototype.slice.call(this.files || []);
        if (!files.length) {
          if (fileList) fileList.textContent = '';
          if (fileLabel) fileLabel.textContent = 'Cliquez pour ajouter des photos';
          return;
        }
        if (fileList) fileList.textContent = files.map(function (f) { return f.name; }).join(', ');
        if (fileLabel) fileLabel.textContent = files.length + ' photo(s) sélectionnée(s)';
      });
    }

    var statusMarker = document.getElementById('lm-rep-form-status');
    var success = document.getElementById('lm-rep-success');
    var quoteForm = document.getElementById('lm-rep-quote-form');

    if (statusMarker && statusMarker.getAttribute('data-posted-successfully') === 'true' && success) {
      if (quoteForm) quoteForm.style.display = 'none';
      success.classList.add('lm-visible');

      // ---- Filet de sécurité WhatsApp ----
      // On ne peut pas relire les valeurs du formulaire après rechargement (Shopify
      // vide les champs au posted_successfully), donc on relit ce qui a été
      // sauvegardé juste avant la soumission via sessionStorage.
      try {
        var saved = sessionStorage.getItem('lm_rep_last_submission');
        if (saved) {
          var data = JSON.parse(saved);
          var lines = [
            'Nouvelle demande de devis réparation (LeMobile) :',
            'Nom : ' + (data.nom || '-') + ' ' + (data.prenom || ''),
            'Téléphone : ' + (data.phone || '-'),
            'Email : ' + (data.email || '-'),
            'Marque : ' + (data.marque || '-'),
            'Modèle : ' + (data.modele || '-'),
            'Réparation : ' + (data.reparation || '-'),
            'Description : ' + (data.description || '-')
          ];
          var waText = encodeURIComponent(lines.join('\n'));
          var waLink = document.createElement('a');
          waLink.href = 'https://wa.me/' + WHATSAPP_NUMBER + '?text=' + waText;
          waLink.target = '_blank';
          waLink.rel = 'noopener';
          waLink.className = 'lm-btn lm-btn-ghost lm-btn-lg';
          waLink.style.marginTop = '16px';
          waLink.textContent = 'Confirmer aussi par WhatsApp (recommandé)';
          if (success) success.appendChild(waLink);
          sessionStorage.removeItem('lm_rep_last_submission');
        }
      } catch (e) { /* silencieux, le filet est optionnel */ }
    }

    // Sauvegarde des valeurs juste avant soumission, pour le filet WhatsApp ci-dessus
    if (quoteForm) {
      quoteForm.addEventListener('submit', function () {
        try {
          var data = {
            nom: document.getElementById('lm-rep-lastname') ? document.getElementById('lm-rep-lastname').value : '',
            prenom: document.getElementById('lm-rep-firstname') ? document.getElementById('lm-rep-firstname').value : '',
            phone: document.getElementById('lm-rep-phone') ? document.getElementById('lm-rep-phone').value : '',
            email: document.getElementById('lm-rep-email') ? document.getElementById('lm-rep-email').value : '',
            marque: document.getElementById('lm-rep-brand') ? document.getElementById('lm-rep-brand').value : '',
            modele: document.getElementById('lm-rep-model') ? document.getElementById('lm-rep-model').value : '',
            reparation: document.getElementById('lm-rep-repair-type') ? document.getElementById('lm-rep-repair-type').value : '',
            description: document.getElementById('lm-rep-issue') ? document.getElementById('lm-rep-issue').value : ''
          };
          sessionStorage.setItem('lm_rep_last_submission', JSON.stringify(data));
        } catch (e) { /* silencieux */ }
      });
    }
  });
})();
